enum TimeUnit {
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  DAYS = 'DAYS',
  YEARS = 'YEARS'
}

export default TimeUnit
